module.exports = __webpack_public_path__ + "img/horizontal_6_1_pp1_8017.d32fdec4.png";